module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toolbar"
  }, [_c('div', {
    staticClass: "top",
    on: {
      "click": _vm.scrollTop
    }
  }, [_vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('span', {
    staticClass: "iconfont"
  }, [_vm._v("")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-72412ff2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/combo/toolbar.vue
// module id = 614
// module chunks = 1